"use client";

import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";
import { cn } from "../../lib/utils";

interface SwitchProps
  extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> {
  onLabel?: string;
  offLabel?: string;
  thumbClassName?: string;
}

const SwitchInput = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  SwitchProps
>(
  (
    {
      className,
      onLabel = "AI ON",
      offLabel = "AI OFF",
      thumbClassName,
      checked,
      disabled,
      ...props
    },
    ref
  ) => {
    return (
      <div className="flex items-center space-x-2">
        <SwitchPrimitives.Root
          ref={ref}
          checked={checked}
          disabled={disabled}
          className={cn(
            "peer inline-flex h-6 w-12 shrink-0 cursor-pointer items-center rounded-full transition-colors",
            "data-[state=checked]:bg-[#9E01FF] data-[state=unchecked]:bg-gray-300",
            "disabled:opacity-50 disabled:cursor-not-allowed", 
            className
          )}
          {...props}
        >
          <SwitchPrimitives.Thumb
            className={cn(
              "pointer-events-none block h-5 w-5 rounded-full bg-white shadow transition-transform",
              thumbClassName
            )}
            style={{
              transform: checked ? "translateX(26px)" : "translateX(2px)",
            }}
          />
        </SwitchPrimitives.Root>
        <span className={cn("text-sm font-bold", disabled ? "text-gray-300" : "text-[#6F7D95]" )}>
          {checked ? onLabel : offLabel}
        </span>
      </div>
    );
  }
);
SwitchInput.displayName = "SwitchInput";

export { SwitchInput };
